





















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { resHandle } from "@/plugins/axios";
import Copy from "@/components/copy.vue";
@Component({
  components: {
    Copy
  }
})
export default class ModelReport extends Vue {
  private modelId: any = "";
  private model: any = {};
  private versions: any[] = [];
  private cVersion: any = {};
  private report: any = {};
  // 图表配置
  private basePieOption: any = {
    series: [
      {
        type: "pie",
        radius: ["60%", "70%"],
        label: {
          normal: {
            show: true,
            position: "center",
            textStyle: {
              fontSize: "18",
              fontWeight: "bold"
            }
          },
          emphasis: {
            show: true
          }
        }
      }
    ]
  };
  private xunlianOption: any = {};
  private zhunquelvOption: any = {};
  private jingquelvOption: any = {};
  private zhaohuilvOption: any = {};
  private f1Option: any = {};
  private zhunquelvxiaoguoOption: any = {};
  private loaded: boolean = false;
  private get hashKey() {
    return new Date().getTime();
  }
  /**
   * @description 获取版本列表
   */
  private fetchVersions(ifVersion?) {
    const params: any = {
      params: {
        model_id: this.modelId
      }
    };
    axios.get("api/model/report/versions", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.model = data.data;
        this.versions = data.data.versions;
        if (ifVersion) {
          this.versions.map((version: any) => {
            if (version.version_id === this.cVersion.version_id) {
              this.cVersion = version;
            }
          });
        } else {
          this.cVersion = this.versions[0];
        }

        this.fetchReportDetail();
      });
    });
  }
  /**
   * @description 获得报告详情
   */
  private fetchReportDetail() {
    const params: any = {
      params: {
        version_id: this.cVersion.version_id
      }
    };
    axios.get("api/model/report/version", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.report = data.data;
        this.createXunlian();
        this.createXingneng();
        this.createZhunquelvxiaoguo();
        this.loaded = true;
      });
    });
  }
  /**
   * @description 切换当前版本
   */
  private triggerVersion(version) {
    this.cVersion = version;
    this.fetchReportDetail();
  }
  /**
   * @description 训练情况
   */
  private createXunlian() {
    this.xunlianOption = _.cloneDeep(this.basePieOption);
    this.xunlianOption.color = ["#F36C6C", "#EAE8EB"];
    this.xunlianOption.series[0].name = "准确率";
    this.xunlianOption.series[0].radius = ["65%", "80%"];
    this.xunlianOption.series[0].data = [
      { value: (this.report["准确率"] * 100).toFixed(2), name: "准确率" },
      { value: 100 - this.report["准确率"] * 100, label: { show: false } }
    ];
    this.xunlianOption.series[0].label.normal.formatter = "{b}\n\n{c}%";
  }
  /**
   * @description 性能结果
   */
  private createXingneng() {
    //   准确率
    this.zhunquelvOption = _.cloneDeep(this.basePieOption);
    this.zhunquelvOption.color = ["#50A7F7", "#EAEAEA"];
    this.zhunquelvOption.series[0].name = "准确率";
    this.zhunquelvOption.series[0].label.normal.show = false;
    this.zhunquelvOption.series[0].label.emphasis.show = false;
    this.zhunquelvOption.series[0].labelLine = { show: false };
    this.zhunquelvOption.series[0].radius = ["60%", "80%"];
    this.zhunquelvOption.series[0].data = [
      { value: this.report["准确率"] * 100, name: "准确率" },
      { value: 100 - this.report["准确率"] * 100 }
    ];
    //   精确率
    this.jingquelvOption = _.cloneDeep(this.basePieOption);
    this.jingquelvOption.color = ["#50A7F7", "#EAEAEA"];
    this.jingquelvOption.series[0].name = "精确率";
    this.jingquelvOption.series[0].label.normal.show = false;
    this.jingquelvOption.series[0].label.emphasis.show = false;
    this.jingquelvOption.series[0].labelLine = { show: false };
    this.jingquelvOption.series[0].radius = ["60%", "80%"];
    this.jingquelvOption.series[0].data = [
      { value: this.report["精确率"] * 100, name: "精确率" },
      { value: 100 - this.report["精确率"] * 100 }
    ];
    //   F1-score
    this.f1Option = _.cloneDeep(this.basePieOption);
    this.f1Option.color = ["#50A7F7", "#EAEAEA"];
    this.f1Option.series[0].name = "F1-score";
    this.f1Option.series[0].label.normal.show = false;
    this.f1Option.series[0].label.emphasis.show = false;
    this.f1Option.series[0].labelLine = { show: false };
    this.f1Option.series[0].radius = ["60%", "80%"];
    this.f1Option.series[0].data = [
      { value: this.report["f1_score"] * 100, name: "f1-score" },
      { value: 100 - this.report["f1_score"] * 100 }
    ];
    //   召回率
    this.zhaohuilvOption = _.cloneDeep(this.basePieOption);
    this.zhaohuilvOption.color = ["#50A7F7", "#EAEAEA"];
    this.zhaohuilvOption.series[0].name = "召回率";
    this.zhaohuilvOption.series[0].label.normal.show = false;
    this.zhaohuilvOption.series[0].label.emphasis.show = false;
    this.zhaohuilvOption.series[0].labelLine = { show: false };
    this.zhaohuilvOption.series[0].radius = ["60%", "80%"];
    this.zhaohuilvOption.series[0].data = [
      { value: this.report["召回率"] * 100, name: "召回率" },
      { value: 100 - this.report["召回率"] * 100 }
    ];
  }
  /**
   * @description 多个识别结果准确率效果
   */
  private createZhunquelvxiaoguo() {
    this.zhunquelvxiaoguoOption = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        }
      },
      grid: {
        left: "5%"
      },
      color: ["#5B8FF9"],
      yAxis: [
        {
          type: "value"
        }
      ],
      xAxis: {
        type: "category",
        data: this.report["准确率效果"].name
      },
      series: [
        {
          name: "准确率效果",
          type: "bar",
          barWidth: "40",
          data: this.report["准确率效果"].data
        }
      ]
    };
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.modelId = this.$route.params.model_id;
    if (this.$route.params.version_id) {
      this.cVersion.version_id = this.$route.params.version_id;
      this.fetchVersions(true);
    } else {
      this.fetchVersions();
    }
  }
}
